module.exports = "/static/assets/0136d7b1618e6d7ecaf97717bd128a05.jpg";